var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { Card } from '@juvare/common-web-ui/Card';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Box } from '@mui/material';
import React from 'react';
import { getAlertIcon } from '../../../../../utils';
import { templateIcons } from '../../AlertFab/types';
export function showTemplateEditDialog(alertData, userState, t, alertServiceClient, alertStorageClient, onSubmitSuccess, onCancel) {
    showFormDialog({
        title: alertData.id ? t('common.saveTemplate') : t('pages.edit.recipients.saveAsNewTemplate'),
        data: {
            title: alertData.title,
            icon: alertData.icon,
            color: alertData.color,
        },
        submitLabel: t('common.save'),
        globalWidgetConfig: {
            iconPickerIcons: Object.assign({}, templateIcons),
        },
        config: {
            type: 'form',
            children: [
                {
                    type: 'form.label',
                    key: 'titleLabel',
                    html: `<strong>${t('pages.edit.templateTitle')}</strong>`,
                },
                {
                    type: 'form.text',
                    key: 'title',
                    label: t('common.title'),
                    validate: {
                        required: true,
                        maxLength: 100,
                    },
                },
                {
                    type: 'form.label',
                    key: 'iconLabel',
                    html: `<strong>${t('pages.edit.icon')}</strong>`,
                },
                {
                    type: 'form.iconPicker',
                    key: 'icon',
                },
                {
                    type: 'form.label',
                    key: 'colorLabel',
                    html: `<strong>${t('pages.edit.color')}</strong>`,
                },
                {
                    type: 'form.colorPicker',
                    key: 'color',
                },
                {
                    type: 'form.label',
                    key: 'previewLabel',
                    html: `<strong>${t('common.preview')}</strong>`,
                },
                {
                    type: 'form.content',
                    render: (handler) => {
                        var _a;
                        const TemplateIcon = getAlertIcon(handler.formData.icon);
                        return (React.createElement(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: themeColors.background,
                                height: 120,
                            } },
                            React.createElement(Card, { icon: React.createElement(TemplateIcon, null), iconColor: (_a = handler.formData.color) !== null && _a !== void 0 ? _a : 'grey', contentTitle: handler.formData.title ? handler.formData.title : '' })));
                    },
                },
                ...(alertData.id
                    ? []
                    : [
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                            },
                            children: [
                                {
                                    type: 'form.content',
                                    key: 'content',
                                    style: {
                                        width: 0,
                                    },
                                    template: {
                                        data: '',
                                        content: '<span style="margin-top: 8px" class="icon-push-pin grey-500">',
                                    },
                                },
                                {
                                    type: 'form.checkbox',
                                    key: 'pinned',
                                    label: t('pages.tables.pinThisTemplate'),
                                    style: {
                                        type: 'switch',
                                        labelPlacement: 'start',
                                    },
                                },
                            ],
                        },
                    ]),
            ],
        },
        onCancel: () => {
            if (onCancel) {
                onCancel();
            }
        },
        onSubmit: (data) => __awaiter(this, void 0, void 0, function* () {
            try {
                const template = Object.assign(Object.assign({}, alertData), { type: 'template', title: data.title, icon: data.icon, color: data.color });
                const response = yield alertStorageClient.saveAlert(template);
                if (!data.id && data.pinned) {
                    yield alertServiceClient.pinAlert(response.id, [{ type: 'user', externalId: userState.id }]);
                }
                showAlertSnackbar({
                    message: t('pages.edit.snackbar.template.saved'),
                    type: 'success',
                    autoHideDuration: 1000,
                });
                if (onSubmitSuccess) {
                    onSubmitSuccess(template);
                }
            }
            catch (error) {
                handleErrorDialog(error);
            }
        }),
    });
}
